export default {
  container: {
    maxWidth: "180px",
    height: "auto",
    marginBottom: "20px",
    marginTop: "20px",
  },
};
